import { render, staticRenderFns } from "./DetailReservation.vue?vue&type=template&id=38a3bc11"
import script from "./DetailReservation.vue?vue&type=script&lang=js"
export * from "./DetailReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports